import { Popover, PopoverTrigger } from '@e2n/ui';
import { StyleProps } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/desktop/components/station/types';
import { KalenderByMitarbeiterStation } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/kalenderByMitarbeiter/KalenderStation';
import { KalenderAbwesenheit } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/kalenderByMitarbeiter/KalenderAbwesenheit';
import { useHoverPopover } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/desktop/components/station/useHoverPopover';
import { MitarbeiterStationIntervalContent } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/desktop/components/station/MitarbeiterStationIntervalContent';
import { MitarbeiterAbwesenheitIntervalContent } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/desktop/components/station/MitarbeiterAbwesenheitIntervalContent';
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';

function getGridRowClasses({
  hasOverlaps,
  interval,
}: {
  hasOverlaps: boolean;
  interval: KalenderByMitarbeiterStation | KalenderAbwesenheit;
}): string {
  if (!hasOverlaps) {
    return 'row-start-1 row-span-2';
  }

  if (interval instanceof KalenderAbwesenheit) {
    return 'row-start-2 row-span-1';
  }

  return 'row-start-1 row-span-1';
}

export function MitarbeiterKalenderInterval({
  interval,
  konfliktStationen,
  displayYear,
  hasOverlaps,
}: {
  interval: KalenderByMitarbeiterStation | KalenderAbwesenheit;
  konfliktStationen: ArbeitsbereichStation[];
  displayYear: number;
  hasOverlaps: boolean;
}) {
  const { ref, open, setOpen, cursorX, handleMouseEnter, handleMouseLeave } =
    useHoverPopover();

  return (
    <div
      className={`col-start-(--col-start) col-end-(--col-end) py-0.5 ${getGridRowClasses({ hasOverlaps, interval })}`}
      style={
        {
          '--col-start': interval.getColStart(displayYear),
          '--col-end': interval.getColEnd(displayYear),
        } as StyleProps
      }>
      <div className="relative w-full h-full" ref={ref}>
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger
            style={{
              position: 'absolute',
              left: cursorX,
              bottom: 0,
              height: 1,
              width: 1,
              color: 'transparent',
            }}
          />
          {interval instanceof KalenderByMitarbeiterStation ? (
            <MitarbeiterStationIntervalContent
              interval={interval}
              konfliktStationen={konfliktStationen}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            />
          ) : (
            <MitarbeiterAbwesenheitIntervalContent
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              interval={interval}
            />
          )}
        </Popover>
      </div>
    </div>
  );
}
